import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";

export async function checkJobStatus(jobid: string) {
    if(!jobid) return Promise.reject(new Error("Invalid jobid"))

    // function to check job status
    async function pollStatus(): Promise<any> {
        let result = await ServiceWrapper.doGet(
            AppSettings.GMS_BACKEND_API_URL + "job/status/" + jobid,
            null,
            null,
            AuthManager.getGmsToken()
        );
        
        if(result.errorfound || result.data.error) 
            return Promise.reject(new Error(result.data.status ?? "Job fetch failed"))

        if((result && result.data && result.data.data) || !result.data.processing) 
            return result.data

        await new Promise((resolve) => setTimeout(resolve, 1000))
        return pollStatus()
    }

    return pollStatus()
  }